import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 2.8.",
  "description": "",
  "published": "2011-08-02T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-2-8/swizec/2059"],
  "categories": "Learning, Personal, Social media, Twitter",
  "hero": "./img/2534-4187565894_1e319e7ce0_m.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "164px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/7bdb09fee56c037ca4bec9cb9c15d05a/743a6/2534-4187565894_1e319e7ce0_m.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "146.34146341463415%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'585\\'%20viewBox=\\'0%200%20400%20585\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M16%2016l-1%20106%201%20104%203%203%2010%207%206%203-7-1H16l-1%2061%201%2065c0%205%202%205%204%200l6-7%206-9c6-7%206-6%203%2014l-2%207-1%203c2%203%204-1%205-8l2-8%201-9%201-8a244%20244%200%200124-30l12-13%206-7%204-6v-9c1-5%201-10-2-15-3-6-3-6%203-5l5-1-1-2c-1-1%200-1%201-1%205%200%2010-13%205-15-3%200-2-1%201-3%202-2%202-2%203%200l1%202%206%204c5%205%2011%207%2041%2011l9%202a8885%208885%200%200175-7c2-1%205%203%206%205l1%206v-6c0-7%200-7%202-8%203-2%206%200%206%204%200%203%207%2024%2010%2029%204%208%209%2013%2016%2016%205%203%206%204%207%207%202%208%2016%2012%2026%207%202-2%206-3%207-3%209%200%2017-4%2023-10l7-7%208%205%2032%2016v-7l-8-4c-11-6-28-16-29-18l1-2v-5l3-6%204-11%204-11%203-9a415%20415%200%20014-23l1-10a5180%205180%200%200116%2038c1%201%201-3%201-34a21448%2021448%200%20010-187c-2-2-369-2-369%200m154%2053a453%20453%200%2000-32%203l-1%208v8h5l38-4%208-1v-4l-1-7c-1-4-3-4-17-3m-45%204l-5%201c-3%200-5%202-6%204h-4c-2-1-3-1-5%201l-4%202c-2%200-3%204-3%207%201%204-1%205-9%206-9%201-12%202-12%205-1%204-1%204%2012-1l6-1c6%200%2012-3%2012-5s1-2%205-2l4%201h8l4-1v-7c0-7-1-12-3-10m-72%2086l-2%202-3%201c-4%200-20%209-20%2011l3%201c2-1%202%200%202%201%200%202-1%202-3%202-3%200-3%200%203%205%204%203%205%203%207%202%206-2%2014-2%2018%200%205%203%206%203%207-2%203-11%202-15-2-13-4%201-5%201-5-4%200-7-1-8-5-6m91%20112l-8%204c-8%203-8%207%201%2011%203%201%205%202%206%201l5-1c3%200%208-3%2010-7%203-4%201-9-4-8h-10m-10%2085l-7%204-7%204c-3%201-3%203%200%203%2013%200%2022%208%2022%2020%200%203-18%2021-35%2034a170%20170%200%2000-15%2013l-8%207-4%203-3%203c-3%202-5%202-5%200l7-7%201-2%202-2c3-1-1-8-5-7l-2%202-1%201-5%203c-4%203-5%204-7%203h-4c-2%202-5%201-4%200l2-1%201-1%204-5a387%20387%200%200034-38%20409%20409%200%2001-46%2038l-1%201c1%201%200%202-1%202l-1%201-1%201c-3%201-2-1%201-5l14-14c3-3%205-4%206-3%202%200%203-1%204-3%202-4%202-5%201-5l-2%201-2%201-7%206-18%2013c-1%200-3%201-3%203l-2%202-7%204c-9%207-10%208-10%205l-1-5h-1l-1%205-2%2086%201%2044h370l-1-96v-97c0-2-30%200-37%203-4%201-6%201-21-2a213%20213%200%2000-18-3%20231%20231%200%2000-24-5%20286%20286%200%2000-28-6l-10-2-12-1%2016%204%205%201%2011%202a189%20189%200%200123%206l8%201a563%20563%200%200048%2010l2%201h-10l-11-2-3-1-4-1-13-2a1390%201390%200%2000-76-15c-9-2-10-1-17%208a1729%201729%200%2001-46%2062c-5%206-5%207-4%208%202%202%2026%208%2045%2012a416%20416%200%200161%2020l-5-2c-4%200-7%201-5%202%201%202-1%203-6%203-2%200-3%200-2%201%200%202-3%202-4%201h-2l-4%202c-1%200-2%201-2%203l2%202c4%200%2022%2013%2022%2016l1%201%204%206%201%203c2%205-1%207-6%206l-2%201-11%203-10%202-7%201c-4%201-5%201-8-2-8-8-16-10-28-8-8%201-18%205-21%208-3%204-19%202-21-3-2-4-11-5-14-2-3%202-6%201-6-1l1-2%201-3a65%2065%200%200136-26c2-1%202-1-2-1l-4-1-9-1c-13-1-23-5-23-8l-2-4c-2-2-2-2-1-4%202-4%201-4-3%200-10%2011-12%2013-14%2012-2%200-3%201-1%203s-15%2020-19%2020l-11-7-5-2-3-3-3-2c-2%200-3-2-3-4s-1-2-4-2c-2%200-3%200-3-2l1-2%203-8%202-8a515%20515%200%200164-62c13-11%2016-15%2018-24%202-10%200-16-8-21-4-2-6-2-10-1M25%20399c-1%202-1%202-2%200-2-2-7%200-7%202%200%203%205%205%207%203%201-1%202-2%204-1l3-1%203-1c2%200%203-1%203-3%200-3-8-3-11%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7bdb09fee56c037ca4bec9cb9c15d05a/93f72/2534-4187565894_1e319e7ce0_m.webp 164w"],
                "sizes": "(max-width: 164px) 100vw, 164px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7bdb09fee56c037ca4bec9cb9c15d05a/743a6/2534-4187565894_1e319e7ce0_m.jpg 164w"],
                "sizes": "(max-width: 164px) 100vw, 164px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7bdb09fee56c037ca4bec9cb9c15d05a/743a6/2534-4187565894_1e319e7ce0_m.jpg",
                "alt": "Social Media Outposts",
                "title": "Social Media Outposts",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Social Media Outposts`}</figcaption>{`
  `}</figure></p>
    <p>{`Today I learned that being typecast as the Social Media Guy can put you in some pretty interesting spots. Doublerecall seems to have decided that when a launch page is made for something we're thinking about Swizec is the guy who will figure out how to get enough traffic to run a valid experiment. Thing is ... I don't know the first thing about doing that. Sure, I sometimes get lucky and get 6k visitors to some random things I say about the `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/living-life-in-25min-increments/swizec/1859",
        "title": "Living life in 25min increments"
      }}>{`pomodoro technique`}</a>{` and stuff like that.`}</p>
    <p>{`The real difficulty is in doing this consistently, figuring out what works, what doesn't and being able to produce thousands of traffic to a random webpage with at least a hint of regularity and reliability.`}</p>
    <p>{`I learned that maybe e-marketers might be useful people too.`}</p>
    <p>{`Today I also learned that despite how many times I spill my glass of water after putting it on the floor next to my bed when I decide to work on the bed I will never learn to stop doing that. It's just so convenient and the ratio of spilling the drink versus the times I don't just isn't enough to trip up my learning process apparently ... that is to say, the force of being lazy is just stronger.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-1-8/swizec/2054"
        }}>{`I learned two things today 1.8.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/2037/swizec/2037"
        }}>{`I learned two things today 30.7.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-29-7/swizec/2022"
        }}>{`I learned two things today 29.7.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/living-life-in-25min-increments/swizec/1859"
        }}>{`Living life in 25min increments`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://codeartists.posterous.com/codeartists-team-was-invited-to-y-combinator"
        }}>{`CodeArtists team was invited to Y Combinator S11 Interview with DoubleRecall project`}</a>{` (codeartists.posterous.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=cc5e9b01-b047-4525-afc9-5e13d304886b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      